(function(){
  /* ---------- What's inside: tap a piece ---------- */
  var INFO={intro:['warmth is wellness.','Tap any piece to see what it does inside the warmer.'],
    air:['Air','Nothing happens until you open the pouch. Air is the switch that starts the heat.'],
    iron:['Iron powder','Reacts with oxygen and releases heat, slowly, for hours.'],
    salt:['Salt','Helps the iron react steadily so warmth builds within minutes.'],
    carbon:['Activated carbon','Holds air and moisture close to the iron and spreads heat evenly.'],
    vermiculite:['Vermiculite','A light mineral that holds water and keeps the heat in.'],
    water:['Water','Gives the reaction what it needs to keep going all day.'],
    core:['The warmer','Thin and soft enough for sneakers, boots, loafers or slippers.']};
  var title=document.getElementById('nca-active-title'), text=document.getElementById('nca-active-text');
  function pick(k){
    if(!title||!text||!INFO[k]) return;
    title.textContent=INFO[k][0]; text.textContent=INFO[k][1];
    document.querySelectorAll('[data-ing-label]').forEach(function(el){ el.style.color = el.getAttribute('data-ing-label')===k ? '#F7C948' : 'rgba(243,235,221,.6)'; });
  }
  document.querySelectorAll('[data-ing]').forEach(function(b){
    var k=b.getAttribute('data-ing');
    ['mouseenter','focus','click'].forEach(function(ev){ b.addEventListener(ev,function(){ pick(k); }); });
  });

  /* ---------- Pack cards: highlight the chosen one ---------- */
  function selectPack(id){
    document.querySelectorAll('[data-card]').forEach(function(c){
      var on=c.getAttribute('data-card')===String(id);
      c.style.background = on ? '#1A100C' : '#120F0D';
      c.style.borderColor = on ? '#F2A33A' : 'rgba(243,235,221,.14)';
      var btn=c.querySelector('.nca-pack-btn');
      if(!btn) return;
      btn.style.background = on ? '#F2A33A' : 'transparent';
      btn.style.color = on ? '#0B0908' : '#F3EBDD';
      btn.style.border = on ? '0px solid transparent' : '1px solid rgba(243,235,221,.4)';
    });
  }
  document.querySelectorAll('.nca-pack-btn').forEach(function(b){ b.addEventListener('click',function(){ selectPack(b.getAttribute('data-pack')); }); });
  document.querySelectorAll('[data-buy-now]').forEach(function(a){ a.addEventListener('click',function(){ selectPack(3); }); });

  /* ---------- Add to bag without leaving the page ---------- */
  var toast=document.getElementById('nca-toast'), toastTimer=null;
  function showToast(msg){
    if(!toast) return;
    toast.querySelector('[data-nca-toast-text]').textContent=msg;
    toast.hidden=false; toast.classList.add('is-on');
    clearTimeout(toastTimer); toastTimer=setTimeout(function(){ toast.classList.remove('is-on'); setTimeout(function(){ toast.hidden=true; },300); },4000);
  }
  function setCount(n){ document.querySelectorAll('[data-nca-count]').forEach(function(el){ el.textContent=n; }); }
  document.querySelectorAll('form[data-nca-add]').forEach(function(form){
    form.addEventListener('submit',function(e){
      if(!window.fetch || !window.NCA) return; // plain form post fallback
      e.preventDefault();
      var btn=form.querySelector('button'), label=btn ? btn.textContent : '';
      if(btn){ btn.disabled=true; btn.textContent='Adding…'; }
      var fd=new FormData(form);
      if(fd.get('selling_plan')==='') fd.delete('selling_plan');
      fetch(window.NCA.cartAddUrl,{method:'POST',headers:{'Accept':'application/json'},body:fd})
        .then(function(r){ return r.json().then(function(j){ if(!r.ok) throw j; return j; }); })
        .then(function(){ return fetch(window.NCA.cartUrl+'.js').then(function(r){ return r.json(); }); })
        .then(function(cart){ setCount(cart.item_count); showToast('Added to your bag'); })
        .catch(function(err){ showToast((err && (err.description||err.message)) || 'Could not add that, please try again'); })
        .then(function(){ if(btn){ btn.disabled=false; btn.textContent=label; } });
    });
  });

  /* ---------- Spinning insole + floating ingredients ---------- */
  var insole=document.getElementById('nca-insole'), inside=document.getElementById('inside');
  if(!insole && !inside) return;
  var floaters=inside ? inside.querySelectorAll('[data-speed]') : [];
  var reduce=window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var t0=null, SPEED=22;
  function tick(t){
    if(t0===null) t0=t;
    if(insole){
      var a=(reduce?0:((t-t0)/1000)*SPEED)+window.scrollY*0.35;
      insole.style.transform='rotateZ(-14deg) rotateY('+a.toFixed(1)+'deg)';
    }
    if(inside){
      var r=inside.getBoundingClientRect();
      if(r.bottom>-200 && r.top<window.innerHeight+200){
        var off=Math.max(-700,Math.min(700,(r.top+r.height/2)-window.innerHeight/2));
        for(var i=0;i<floaters.length;i++){ floaters[i].style.transform='translateY('+(off*(parseFloat(floaters[i].getAttribute('data-speed'))||0)).toFixed(1)+'px)'; }
      }
    }
    requestAnimationFrame(tick);
  }
  requestAnimationFrame(tick);
})();
